import React from "react";
import "../Css/Accounts.css";
import {Language} from "../types";

interface LanguageSectionProps {
    languages?: Language[],
}

export function LanguageSection({languages}:LanguageSectionProps) {

    return (
        <section className="cv-section">
            <h2>Languages</h2>
            <ul className="cv-languages">
                {languages?.map((language) => (
                    <li key={language.name}><strong>{language.name}</strong> ({language.level})</li>
                ))}
            </ul>
        </section>
    );
}
